var data = { header:{ text:"#### This selection is not supported for your location at this time:" },
  body:{ text:"{{it.testNames}}<br>\n\n{{@if(it.customErrorMessage)}}\n  {{it.customErrorMessage}}\n{{#else}}\n  This selection could not be added to your cart.\n{{/if}}\n\n{{@if(it.replacements.length > 0)}}\n  To add **{{it.categories}}** to your cart please **remove** the invalid add-on or **replace** {{it.article}} with\n  following:\n{{/if}}\n\n{{it.replacements}}",
    postProcessingAction:"processLocationValidationError" },
  buttons:[ { text:"OK",
      isPrimary:true } ] };
data.header;
data.body;
data.buttons;

export { data as default };
//# sourceMappingURL=location_validation_error.esm.js.map
